import { initInterestButton } from './EstatePropertyInterestButton';
import { initEstatePropertyInterestFormIsland } from './EstatePropertyInterestFormIsland';

export default function initEstatePropertyInterest() {
    initInterestButton();
    initEstatePropertyInterestFormIsland();
}
